import React from 'react';
import FounderMessage4 from '../components/sections/FounderMessage4';
import Banner4 from '../components/sections/Banner4';

const About = () => {
  const teamMembers = [
    {
      name: 'Jaimin Patel',
      role: 'CEO & Founder',
      image: '/images/team/jaimin.png',
    },
    {
      name: 'Rutvik Panchal',
      role: 'COO & Brand Manager',
      image: '/images/team/rutvik.png',
    },
    {
      name: 'Bhumika Padiyar',
      role: 'Amazon Expert(Content Writer)',
      image: '/images/team/bhumi.png',
    },
    {
      name: 'Harshil Patel',
      role: 'Amazon Analytics and Reporting Expert',
      image: '/images/team/harshil.png',
    },
    {
      name: 'Divya Panchal',
      role: 'Amazon Executive',
      image: '/images/team/divya.png',
    },
    {
      name: 'Ritu Ghelot',
      role: 'Graphic Designer',
      image: '/images/team/ritu.png',
    }
  ];

  return (
    <div className="min-h-screen bg-cream dark:bg-black">
      
      {/* Hero Section */}
      <section className="relative min-h-screen pt-10 md:pt-20">

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-6xl mx-auto pt-20">
            <div className="text-center mb-16">
              <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-primary mb-8">
                About Us
              </h1>
              <p className="text-2xl md:text-2xl text-gray-300 font-light leading-relaxed max-w-4xl mx-auto">
                TrioPerspective is a specialized Amazon Seller Central services agency dedicated to helping businesses thrive on Amazon.
              </p>
              <p className="text-xl md:text-xl text-gray-300 font-light leading-relaxed mx-auto text-justify my-4">
              We’ve built our services from years of experience, understanding the unique needs of e-commerce businesses on Amazon. By working closely with our clients and constantly adapting to Amazon’s changes, we’ve learned how to create effective strategies that drive results.
              <br />Our success comes from real-world experience and a track record of helping businesses growth on Amazon. With a team of experienced professionals, we bring efficient processes and smart strategies that help your Amazon business stand out.
              <br />What sets us apart is our dedication to your success. We treat every client as a partner, investing in their growth as if it were our own. Our focus is always on boosting profits and achieving long-term success for your business.
              </p>
            </div>

            {/* Feature Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20">
              {[
                {
                  icon: (
                    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  ),
                  title: 'Expert Solutions',
                  description: 'We design practical strategies that fit your business and help you succeed on Amazon.'
                },
                {
                  icon: (
                    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  ),
                  title: 'Client-Centric',
                  description: 'We listen to your needs and work closely with you to reach your goals.'
                },
                {
                  icon: (
                    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  ),
                  title: 'Proven Results',
                  description: 'Our methods are tested and deliver the growth your business needs.'
                }
              ].map((card, index) => (
                <div
                  key={index}
                  className="group relative bg-[#2a2a2a] rounded-2xl p-8 hover:shadow-2xl transition-all duration-300"
                >
                  <div className="text-primary group-hover:text-orange-dark transition-colors duration-300">
                    {card.icon}
                  </div>
                  <h3 className="text-2xl font-bold text-white mt-6 mb-4">
                    {card.title}
                  </h3>
                  <p className="text-gray-400">
                    {card.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="relative py-32">
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div className="relative">
                <div className="bg-[#2a2a2a] rounded-2xl p-8 md:p-12">
                  <h2 className="text-4xl md:text-5xl font-bold text-primary mb-8">
                    Our Mission
                  </h2>
                  <p className="text-xl text-gray-300 leading-relaxed">
                  Our aim is to support and empower sellers in achieving their business objectives on the Amazon platform. We represent our service consultancy by leveraging our expertise, adopting a client-centric approach, providing customized solutions, maintaining transparent communication, focusing on results, and fostering long-term partnerships with our clients
                  </p>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-6">
                {[
                  { number: '100+', label: 'Clients Served' },
                  { number: '98%', label: 'Success Rate' },
                  { number: '5+', label: 'Years Experience' },
                  { number: '$75M+', label: 'Revenue Generated' }
                ].map((stat, index) => (
                  <div
                    key={index}
                    className="relative bg-[#2a2a2a] rounded-2xl p-8 text-center"
                  >
                    <div className="text-4xl font-bold text-primary mb-2">
                      {stat.number}
                    </div>
                    <div className="text-gray-300">
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="relative py-32">
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-20">
              <h2 className="text-4xl md:text-5xl font-bold text-primary mb-8">
                Meet Our Team
              </h2>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                We are a team of experienced professionals with in-depth knowledge of the Amazon ecosystem
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
              {teamMembers.map((member) => (
                <div
                  key={member.name}
                  className="group relative"
                >
                  <div className="relative bg-[#2a2a2a] rounded-2xl overflow-hidden">
                    <div className="relative h-80 overflow-hidden">
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0"></div>
                      <img
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="relative p-8 text-center">
                      <h3 className="text-2xl font-bold text-white mb-2">
                        {member.name}
                      </h3>
                      <p className="text-primary">
                        {member.role}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Banner4 />
    </div>
  );
};

export default About;
